import { HttpStatusCode } from 'axios';
import { AuthService } from 'services/auth-service';
import { UserService } from 'services/user-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { axiosBaseInstance } from 'shared/utils/axios-instances';
import { globalNavigate } from 'shared/utils/navigation';

export const initAuthInterceptor = () => {
  axiosBaseInstance.interceptors.request.use(
    (config) => {
      if (AuthService.isAuthenticated()) config.headers.Authorization = `Bearer ${AuthService.getAuthToken()}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosBaseInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === HttpStatusCode.Unauthorized && !originalRequest.sent) {
        originalRequest.sent = true;

        try {
          await AuthService.refreshAuthToken();
          return axiosBaseInstance(originalRequest);
        } catch (refreshError) {
          UserService.logout();
          globalNavigate(ROUTE_LINKS.login);
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    }
  );
};
